import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Custom hook that provides the current store and a storeId for dependency tracking
 * Components can use the storeId to trigger effects when the store changes
 */
export function useCurrentStore() {
  const { currentStore } = useAuth();
  const [storeChangeCount, setStoreChangeCount] = useState(0);
  
  // This effect will run whenever the currentStore._id changes
  useEffect(() => {
    if (currentStore?._id) {
      setStoreChangeCount(prev => prev + 1);
    }
  }, [currentStore?._id]);
  
  return {
    currentStore,
    // The storeId + change count can be used as an effect dependency
    storeId: currentStore?._id || '',
    storeChangeCount
  };
} 